export default __webpack_public_path__ + "static/fish-66107e3bc9a302b084ee9157add7761d.jpeg";